import 'react-spring-bottom-sheet/dist/style.css';

import { BottomSheet, BottomSheetProps } from 'react-spring-bottom-sheet';

import * as S from './styled';

export interface BottomFixedSheetProps extends BottomSheetProps {
  open: boolean;
  children: React.ReactNode;
  footer?: React.ReactNode;
  onDismiss: () => void;
}

/**
 * 라이브러리 스펙에 맞게 정의한 것으로 확장할 수 있는 컴포넌트
 * @param props open<boolean>, children<node>
 * @returns
 */
export function BottomFixedSheet(props: BottomFixedSheetProps) {
  const { open, onDismiss, footer, ...rest } = props;

  return (
    <>
      <S.Backdrop
        open={props.open}
        onClick={() => {
          props.onDismiss();
        }}
      />
      <BottomSheet
        {...rest}
        open={open}
        onDismiss={onDismiss}
        blocking={false}
        scrollLocking={false}
        footer={footer}
      >
        <div>{props.children}</div>
      </BottomSheet>
    </>
  );
}
